import { render, staticRenderFns } from "./Intrinsics.vue?vue&type=template&id=50378e97&"
import script from "./Intrinsics.vue?vue&type=script&lang=js&"
export * from "./Intrinsics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports